<template>
  <GoogleFormRegister v-if="isSenakponTenant"/>
  <DefaultRegisterForm v-else/>
</template>

<script setup>

  import { ref, onMounted, watch,  } from "vue"; 
  import GoogleFormRegister from "./GoogleFormRegister.vue";
  import DefaultRegisterForm from "./DefaultRegisterForm.vue";
  import { getTenantId } from '@/mixins/Helpers'
  
  const isSenakponTenant = ref(false)

  onMounted(() => {
    isSenakponTenant.value = getTenantId()?.slice(0, -1).toLowerCase() === 'senakpon'
  })
</script>

